import { FieldGroup, FieldNode, FieldNodeType } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

const GROUP_TYPES: FieldNodeType[] = ['CHECKBOX_GROUP', 'AUTOFILL_GROUP'];

export function countFields(fields: DeepReadonly<FieldNode[]>) {
  const groups = fields.filter((field): field is FieldGroup => GROUP_TYPES.includes(field.type));
  const groupChildrenCount = groups.reduce((acc, cur) => acc + cur.children.length, 0);

  return fields.length - groups.length + groupChildrenCount;
}
